import { Link } from 'react-router-dom';
import PageHero from '@/components/PageHero';
import TripleSection from '@/components/TripleSection';
import CTABanner from '@/components/CTABanner';
import s from '@/components/home.module.css';

const definitions: { not: string; is: React.ReactNode }[] = [
  { not: 'Not', is: <>AVOWAL is <strong>not a law firm.</strong></> },
  { not: 'Not', is: <>ELARIA is <strong>not your lawyer.</strong></> },
  { not: 'Not', is: <>Limited-scope is <strong>not &ldquo;limited service.&rdquo;</strong></> },
  { not: 'Not', is: <>Flat-fee is <strong>not &ldquo;cheap&rdquo;</strong> — it&rsquo;s predictable.</> },
  { not: 'Not', is: <>&ldquo;Patent pending&rdquo; is <strong>not &ldquo;patented.&rdquo;</strong></> },
];

export default function Trust() {
  return (
    <>
      <PageHero
        eyebrow="Trust by construction"
        title="Built so you don't have to take our word for it."
        sub="Trust in legal technology cannot be a slogan. In AVOWAL it is a property of the system: independent attorneys, UPL-safe workflows, and cryptographically verifiable filings."
      />

      <TripleSection
        id="construction"
        label="How trust is enforced"
        title="Accountability, ethics, and proof — in software."
        cards={[
          { num: '/ ATTORNEYS', title: 'Independent, licensed, accountable', body: 'Every attorney on the platform is independently licensed and personally accountable for the work they sign. AVOWAL never holds itself out as legal counsel.' },
          { num: '/ ETHICS', title: 'Built around the UPL line', body: 'Workflows are structured around the unauthorized-practice-of-law rules of each jurisdiction. ELARIA executes; attorneys advise. The line is clear and enforced in software.' },
          { num: '/ PROOF', title: 'Cryptographically verifiable', body: 'Every filing AVOWAL prepares carries a signed manifest of sources, citations, and the chain of edits. Verifiable by court, opposing counsel, or auditor.' },
        ]}
      />

      <section>
        <div className="container">
          <span className={s.sectionLabel}>Say what we are not</span>
          <h2 className={s.sectionTitle}>Clarity is part of the product.</h2>
          <div className={s.defList}>
            {definitions.map((d, i) => (
              <div key={i} className={s.defItem}>
                <span className={s.defNot}>{d.not}</span>
                <span>{d.is}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="sovereign">
        <div className="container">
          <span className={s.sectionLabel}>Sovereign option</span>
          <h2 className={s.sectionTitle}>What never leaves the building.</h2>
          <p className={s.sectionLead}>
            For firms that want it, work product can live entirely on hardware the firm owns. The
            sovereign deployment can run with no third-party processor in the loop and no internet
            connection at all. What never leaves the building cannot be intercepted in transit,
            subpoenaed from a vendor, or used to train someone else&rsquo;s model. Confidentiality and
            privilege obligations remain matters of the attorney&rsquo;s professional judgment.
            Offline-capable deployment is available by engagement.
          </p>
          <Link to="/ai" className={s.moreLink}>
            Learn how agentic AI works &rarr;
          </Link>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
